import React from 'react';
import Radio from '@material-ui/core/Radio';
import { fieldToRadioGroup } from 'formik-material-ui';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import { makeStyles } from '@material-ui/core/styles';
import { Field } from 'formik';

const useStyles = makeStyles((theme) => ({
  radio: {
    color: theme.palette.text.primary,
  },
}));

export const CustomRadioGroup = (props: any) => {
  const classes = useStyles();
  const {
    form: { values, errors, submitCount },
    field: { name },
  } = props;
  const value = name?.split('.').reduce((acc: any, key: any) => acc && acc[key], values);
  const errorMessage = errors && name?.split('.').reduce((acc: any, key: any) => acc && acc[key], errors);
  const enableError = !!submitCount && !props.disabled && errorMessage;
  return (
    <FormControl component="fieldset" error={enableError}>
      <FormLabel component="legend">{props.label}</FormLabel>
      <RadioGroup
        aria-label="gender"
        name="gender1"
        {...fieldToRadioGroup(props)}
        value={'' + value}
      >
        {(props.options || []).map((option: any) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio />}
            label={option.label}
            disabled={props.disabled}
            className={classes.radio}
          />
        ))}
      </RadioGroup>
      {enableError && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  );
};

//<Field {...props} component={RadioGroup}>

const RadioField = (props: any) => <Field {...props} component={CustomRadioGroup} />;

export default RadioField;
